export default __webpack_public_path__ + "static/wy-logo-3-e481e1c640a8d5ffc165a9b82e4b30d4.png";